import styled from "styled-components";

export const SmoothCard = styled.div`
  background-color: var(--palette-background-default);
  padding: var(--spacing-xxLarge);
  border-radius: var(--rounding-medium);
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
  align-items: center;
  justify-content: center;
  min-height: 400px;
  min-width: 500px;
  max-width: 680px;
  box-sizing: border-box;

  /* Very small phones (320px - 479px) */
  @media only screen and (max-width: 479px) {
    padding: 15px;
    width: 98vw;
    min-width: 98vw;
    max-width: 98vw;
    min-height: auto;
  }

  /* Standard phones (480px - 767px) */
  @media only screen and (min-width: 480px) and (max-width: 767px) {
    padding: 20px;
    width: 95vw;
    min-width: 95vw;
    max-width: 95vw;
    min-height: auto;
  }

  /* Tablets and large phones (768px - 1023px) */
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    padding: 25px;
    min-width: 90vw;
    min-height: 400px;
  }
`;
